import { render } from "./TodoWidgetDatePicker.vue?vue&type=template&id=2da680b4&ts=true"
import script from "./TodoWidgetDatePicker.vue?vue&type=script&lang=ts"
export * from "./TodoWidgetDatePicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__